import { Container } from 'react-bootstrap';
import { AnchorScroll } from '../utils/AnchorScroll';
import { useEffect } from 'react';
import Navigation from '../components/base/Navigation';
import { useWindowParams } from '../hooks/useWindowParams';

/**
 * Returns the ErrorPage (/[any invalid URL]) given the following props:
 *
 * - error: The error title to be displayed in the error page.
 * - errorDesc: The description of the error to be displayed in the error page.
 *
 * @returns The component representing the ErrorPage.
 */
export default function ErrorPage({ error, errorDesc }: { error: string; errorDesc: string }) {
  // <img src="crumpled-paper-texture.jpg" className="image-bg" />
  const screenWidth = useWindowParams(true, false)[0];

  document.title = error + ' :(';
  useEffect(AnchorScroll, []);

  return (
    <div className="container-wrap">
      <Navigation selectedPage="Error" screenWidth={screenWidth} />
      <Container className="container container-inner container-xs error-wrap">
        <div className="p-3">
          <h1>{error} :(</h1>
          <p className="big">{errorDesc}</p>
          <p className="big">
            Return to the main page <a href="/">here</a>.
          </p>
        </div>
      </Container>
    </div>
  );
}
